<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <h4 class="text-center">Reporte General</h4>
          <hr class="horizontal dark" />
          <h6 class="mt-1">Reporte General</h6>
          <div class="row">
            <div class="col-md-12">
              <label style="font-weight: 400;">
                Ingresa los datos y realiza tu busqueda
              </label>
            </div>
          </div>
          <div class="row pl-2 pr-2">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Desde</label>
              <datepicker
                v-model="fechaInicio"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Hasta</label>
              <datepicker
                v-model="fechaFin"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Programa</label>
              <vue-select
                :options="programasOptions"
                label="text"
                v-model="programa"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Usuario</label>
              <vue-select
                :options="usuariosOptions"
                label="text"
                v-model="usuario"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Estado</label>
              <vue-select
                :options="statusOptions"
                label="text"
                v-model="estado"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-3">
              <label class="form-control-label">Forma de Pago</label>
              <vue-select
                :options="formasPagoOptions"
                label="text"
                v-model="formaPago"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-7"></div>
            <div class="col-md-2">
              <button class="btn btn-addiuva-dark w-100" style="margin-top:30px;" @click="searchAfiliados" title="Generar">
                <i class="fas fa-search pr-1"></i> Generar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div class="row p-2">
          <Toast />
          <DataTable :value="afiliaciones" ref="dtAfiliaciones" stripedRows paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay afiliaciones que mostrar. </center></template>
            <Column field="nroCertificado" header="Número de Certificado" sortable style="width: 15%"></Column>
            <Column field="programa" header="Programa" sortable style="width: 14%"></Column>
            <Column field="nombreAfiliado" header="Afiliado" sortable style="width: 24%"></Column>
            <Column field="afiliado.documento" header="Documento de Identidad" sortable style="width: 15%"></Column>
            <Column field="afiliado.edad" header="Edad" sortable style="width: 15%"></Column>
            <Column field="afiliado.telefono" header="Teléfono" sortable style="width: 15%"></Column>
            <Column field="afiliado.email" header="Email" sortable style="width: 15%"></Column>
            <Column field="inicioVigencia" header="Fecha Inicio" sortable style="width: 10%"></Column>
            <Column field="finVigencia" header="Fecha Fin" sortable style="width: 10%"></Column>
            <Column field="periodicidad" header="Periodicidad" sortable style="width: 10%"></Column>
            <Column field="tarifa" header="Tarifa" sortable style="width: 8%"></Column>
            <Column field="formaPago" header="Forma de Pago" sortable style="width: 8%"></Column>
            <Column field="estado" header="Estado" sortable style="width:5%; min-width: 2rem">
                <template #body="{ data }">
                    <Tag :value="this.capitalize(data.estado)" :severity="getSeverity(data.estado)" rounded/>
                </template>
            </Column>
            <template #paginatorstart>
              <button class="btn btn-light" @click="exportCSV($event)" title="Exportar" v-if="afiliaciones.length>0">
                <i class="fas fa-download"></i> Exportar CSV
              </button>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import VueSelect from "vue-select";
import Tag from 'primevue/tag';
import Datepicker from 'vuejs3-datepicker';
import Toast from 'primevue/toast';
import axios from 'axios';
import authHeader from '../services/auth-header';
export default {
  name: "Reporte General",
  components: {
    VueSelect,
    DataTable,
    Column,
    Tag,
    Toast,
    Datepicker
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      fechaInicio: null,
      fechaFin:null,
      nombres: null,
      apellidos: null,
      numeroCertificado: null,
      documentoIdentidad: null,
      programa: null,
      programasOptions: [],
      usuario: null,
      usuariosOptions: [],
      estado: null,
      statusOptions: [
        {
          text: 'Vigente',
          value: 'VIGENTE'
        },
        {
          text: 'En Mora',
          value: 'MORA'
        },
        {
          text: 'Anulado',
          value: 'ANULADO'
        }
      ],
      formaPago: null,
      formasPagoOptions: [
        {
          text: 'Efectivo',
          value: 'Efectivo'
        },
        {
          text: 'Tarjeta de Crédito/Débito',
          value: 'Tarjeta de Crédito/Débito'
        }
      ],
      showProfileDropdown: false,
      afiliaciones: [],

    };
  },
  methods: {
    searchAfiliados() {
      this.afiliaciones = [];
      //let myArray = this.fechaInicio != null ? this.fechaInicio.toString().split("T") : [];
      //let fechaInicio = myArray[0] != '' ? myArray[0] : '';
      let payload = {
        "nombres": "",
        "apellidos": "",
        "numero_certificado": "",
        "numero_documento": "",
        "estado": this.estado,
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '',
      }
      // Send Data by Axios
      let url = this.API_URL + "/afiliado/buscar";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let afiliaciones = [];
            data.forEach(a => {
              afiliaciones.push({
                id: a.id_afiliacion ?? '',
                nombreAfiliado: a.nombre_afiliado ?? '',
                nroCertificado: a.numero_certificado ?? '',
                inicioVigencia: a.inicio_vigencia ?? '',
                finVigencia: a.fin_vigencia ?? '',
                programa:  a.programa ?? '',
                periodicidad: a.periodicidad ?? '',
                tarifa: a.tarifa ?? '',
                estado: a.estado ?? '',
                formaPago: a.metodo_pago ?? '',
                afiliado: {
                  idAfiliado: a.afiliado.id_afiliado ?? '',
                  nombres: a.afiliado.nombres ?? '',
                  apellidos: a.afiliado.apellidos ?? '',
                  edad: a.afiliado.edad ?? '',
                  documento: a.afiliado.documento ?? '',
                  telefono: a.afiliado.telefono ?? '',
                  email: a.afiliado.email ?? '',
                }
              });
            });
            afiliaciones.forEach(afiliado => {
              afiliado.tarifa = (afiliado.tarifa != '') ? 'Bs. '+ afiliado.tarifa : '';
            });
            this.afiliaciones = afiliaciones;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getSeverity(status) {
      let severity = null;
      if (status == "ANULADO") severity = "danger";
      if (status == "VIGENTE") severity = "success";
      if (status == "MORA") severity = "warning";
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    getProgramas: function() {
      let url = this.API_URL + "/programas";
      axios
        .get(url, { headers: authHeader() })
        .then(response => {
          if (response.data.status) {
            let programas = [];
            response.data.data.forEach(element => {
              programas.push({
                text: element.nombre,
                value: element.id_programa,
                cantidad_max_personas: element.cantidad_maxima_personas,
                descripcion: element.descripcion});
            });
            this.programasOptions = programas
          }
        })
        .catch(error => {
          console.log("Error: " + error.response.data);
        });
    },
    getUsuarios: function() {
      let url = this.API_URL + "/usuarios";
      axios
        .get(url, { headers: authHeader() })
        .then(response => {
          if (response.data.status) {
            let usuarios = [];
            response.data.data.forEach(element => {
              usuarios.push({
                text: element.persona.nombres + ' ' + element.persona.apellidos,
                value: element.id_usuario
                });
            });
            this.usuariosOptions = usuarios
          }
        })
        .catch(error => {
          console.log("Error: " + error.response.data);
        });
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    validateRoute(){
      let menus = this.getProfileMe?.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    },
    exportCSV() {
      this.$refs.dtAfiliaciones.exportCSV();
    }
  },
  watch: {
    getProfileMe(val) {
      if (val) {
        this.validateRoute();
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
    this.getProgramas();
    this.getUsuarios();
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
</style>